import React, { Component } from 'react';
import { arrayOf, bool, func, shape, string } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm, Field } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { intlShape, injectIntl, FormattedMessage } from '../../util/reactIntl';
import { findOptionsForSelectFilter } from '../../util/search';
import classNames from 'classnames';
import { saveDoc } from '../../util/api';
import { propTypes } from '../../util/types';
import { required, validRBSLI, validNRCPD, validSRLPDC } from '../../util/validators';
import { Form, Button, FieldTextInput, FieldSelect, SecondaryButton } from '../../components';
import config from '../../config';
import hand from '../EditListingLegalForm/helping-hand-alert-transparent.png';
import css from './EditListingRegistrationForm.module.css';

export class EditListingRegistrationFormComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imageQualification: '',
      successQualification: false,
    };
  }
getFilePath = (input) => {
  const path = input && input.value;
  if (path) {
    const parts = path.split('_');
    if (parts.length > 1) {
      const filename = parts.slice(1).join('_');
      return `Your saved file: ${filename}`;
    }
    return `Your saved file: ${path}`;
  }
  return 'Please upload a file and then save the form using the button at the end of this form';
}

  onChangeQualification = e => {
    if (e.target.files[0]) {
      this.setState({
        imageQualification: e.target.files[0],
        successQualification: false,
      });
    }
  };

  render() {
    const { imageQualification, successQualification } = this.state;

    return (
      <FinalForm
        {...this.props}
        mutators={{ ...arrayMutators }}
        render={formRenderProps => {
          const {
            className,
            disabled,
            ready,
            rootClassName,
            handleSubmit,
            intl,
            invalid,
            values,
            pristine,
            saveActionMsg,
            updated,
            updateInProgress,
            fetchErrors,
            filterConfig,
            registrationOptions,
          } = formRenderProps;

          const { updateListingError, showListingsError } = fetchErrors || {};
          const classes = classNames(rootClassName || css.root, className);
          const submitReady = (updated && pristine) || ready;
          const submitInProgress = updateInProgress;
          const submitDisabled = invalid || disabled || submitInProgress;

          const registrationBodyOptions = findOptionsForSelectFilter('registrationBody', filterConfig);
          const registrationLengthOptions = findOptionsForSelectFilter('registrationLength', filterConfig);
          const registrationBodies = {
            rbsli: [validRBSLI, '15****'],
            nrcpd: [validNRCPD, '1******'],
            srlpdc: [validSRLPDC, 'QSLI******'],
          };

          return (
            <Form className={classes} onSubmit={handleSubmit}>
              {updateListingError && (
                <p className={css.error}>
                  <FormattedMessage id="EditListingRegistrationForm.updateFailed" />
                </p>
              )}
              {showListingsError && (
                <p className={css.error}>
                  <FormattedMessage id="EditListingRegistrationForm.showListingFailed" />
                </p>
              )}

              <div className={css.sectionContainer}>
                <h2 className={css.sectionTitle}>
                  <FormattedMessage id="EditListingRegistrationForm.registrationTitle" />
                </h2>
                <FieldSelect
                  className={css.features}
                  id="registration"
                  name="registration"
                  label={intl.formatMessage({ id: 'EditListingRegistrationForm.registrationLabel' })}
                  intl={intl}
                  validate={required(
                    intl.formatMessage({ id: 'EditListingRegistrationForm.registrationStatusValidation' })
                  )}
                >
                  <option disabled value="">
                    Choose from the following...
                  </option>
                  {registrationOptions.map(c => (
                    <option key={c.key} value={c.key}>
                      {c.label}
                    </option>
                  ))}
                </FieldSelect>

                <FieldTextInput
                  className={css.features}
                  type="text"
                  id="qualificationDetails"
                  name="qualificationDetails"
                  label={intl.formatMessage({ id: 'EditListingRegistrationForm.qualificationDetailsLabel' })}
                  placeholder={intl.formatMessage({ id: 'EditListingRegistrationForm.qualificationDetailsPlaceholder' })}
                  minLength={10}
                  validate={required(
                    intl.formatMessage({ id: 'EditListingRegistrationForm.qualificationDetailsValidation' })
                  )}
                />
                <p className={css.formInputHelperInfo}>
                  <FormattedMessage id="EditListingRegistrationForm.qualificationDetailsTip" />
                </p>
              </div>

              <div className={css.sectionContainer}>
                <h2 className={css.sectionTitle}>
                  <FormattedMessage id="EditListingRegistrationForm.qualificationsUploadLabel" />
                </h2>
                <p className={css.helperText}>
                  <FormattedMessage id="EditListingRegistrationForm.qualificationsUploadInstructions" />
                </p>

                <div className={css.elementMargin}>
                  <div className={css.inputContainer}>
                    <input
                      type="file"
                      className={css.upload}
                      accept=".jpg,.jpeg,.png,.pdf"
                      onChange={this.onChangeQualification}
                    />
                    <SecondaryButton
                      type="button"
                      disabled={!imageQualification}
                      onClick={async () => {
                        if (!imageQualification) {
                          console.error('No image chosen');
                          this.setState({ successQualification: false });
                          return;
                        }

                        const uploadResult = await saveDoc({
                          file: imageQualification,
                          originalFilename: imageQualification.name,
                          purpose: 'Qualification',
                        });

                        const fileId = uploadResult.fileId;
                        const filename = imageQualification.name;

                        this.setState({
                          successQualification: true,
                          imageQualification: '',
                        });

                        formRenderProps.form.change('qualificationUpload', `${fileId}_${filename}`);
                      }}
                      className={css.uploadButton}
                    >
                      Upload
                    </SecondaryButton>
                  </div>
                </div>

                {successQualification && (
                  <div className={css.successMessage}>
                    <img src={hand} alt="Signalise helping alert hand" className={css.alertHand} />
                    <p>
                      <strong>
                        <FormattedMessage id="EditListingRegistrationForm.uploadSuccess" />
                      </strong>
                    </p>
                  </div>
                )}

                <Field name="qualificationUpload">
                  {({ input }) => (
                    <p className={css.helperText}>
                      {this.getFilePath(input)}
                    </p>
                  )}
                </Field>
              </div>



              <FieldSelect
                className={css.features}
                id="registrationBody"
                name="registrationBody"
                label={intl.formatMessage({ id: 'EditListingRegistrationForm.registrationBodyLabel' })}
                intl={intl}
                validate={required(
                  intl.formatMessage({ id: 'EditListingRegistrationForm.registrationBodyValidation' })
                )}
              >
                <option disabled value="">
                  Choose from the following...
                </option>
                {registrationBodyOptions.map(c => (
                  <option key={c.key} value={c.key}>
                    {c.label}
                  </option>
                ))}
              </FieldSelect>

              {values.registrationBody && (
                <FieldTextInput
                  className={css.features}
                  type="text"
                  id="registrationNumber"
                  name="registrationNumber"
                  label={intl.formatMessage({ id: 'EditListingRegistrationForm.registrationNumberLabel' })}
                  placeholder={registrationBodies[values.registrationBody]?.[1]}
                  validate={registrationBodies[values.registrationBody]?.[0](
                    intl.formatMessage({ id: 'EditListingRegistrationForm.registrationNumberValidation' })
                  )}
                />
              )}

              <div className={css.sectionContainer}>
                <h3 className={css.sectionTitle}>
                  <FormattedMessage id="EditListingRegistrationForm.registrationExpiryLabel" />
                </h3>
                <FieldSelect
                  id="registrationExpiryMonth"
                  name="registrationExpiryMonth"
                  label={intl.formatMessage({ id: 'EditListingRegistrationForm.registrationExpiryMonthLabel' })}
                  intl={intl}
                  validate={required(
                    intl.formatMessage({ id: 'EditListingRegistrationForm.registrationExpiryMonthValidation' })
                  )}
                >
                  <option disabled value="">
                    Choose a month...
                  </option>
                  {[
                    'January', 'February', 'March', 'April', 'May', 'June',
                    'July', 'August', 'September', 'October', 'November', 'December'
                  ].map(month => (
                    <option key={month} value={month}>
                      {month}
                    </option>
                  ))}
                </FieldSelect>
              </div>

              <FieldSelect
                className={css.features}
                id="registrationLength"
                name="registrationLength"
                label={intl.formatMessage({ id: 'EditListingRegistrationForm.registrationLengthLabel' })}
                intl={intl}
                validate={required(
                  intl.formatMessage({ id: 'EditListingRegistrationForm.registrationLengthValidation' })
                )}
              >
                <option disabled value="">
                  Choose from the following...
                </option>
                {registrationLengthOptions.map(c => (
                  <option key={c.key} value={c.key}>
                    {c.label}
                  </option>
                ))}
              </FieldSelect>

              <Button
                className={css.submitButton}
                type="submit"
                inProgress={submitInProgress}
                disabled={submitDisabled}
                ready={submitReady}
              >
                {saveActionMsg}
              </Button>
            </Form>
          );
        }}
      />
    );
  }
}

EditListingRegistrationFormComponent.defaultProps = {
  rootClassName: null,
  className: null,
  fetchErrors: null,
  filterConfig: config.custom.filters,
};

EditListingRegistrationFormComponent.propTypes = {
  rootClassName: string,
  className: string,
  intl: intlShape.isRequired,
  onSubmit: func.isRequired,
  onChange: func.isRequired,
  saveActionMsg: string.isRequired,
  disabled: bool.isRequired,
  ready: bool.isRequired,
  updated: bool.isRequired,
  updateInProgress: bool.isRequired,
  fetchErrors: shape({
    showListingsError: propTypes.error,
    updateListingError: propTypes.error,
  }),
};

export default compose(injectIntl)(EditListingRegistrationFormComponent);
